import React from 'react';
import { SAMSLpueMethodSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

const SLUG = 'lpue-calc-method';

interface LpueOption {
  value: string;
  label: string;
}

interface LpueCalcMethodData {
  samsLpueMethod?: string;
  dbSamsLpueMethod?: string;
  updatingParams?: boolean;
  lpueOptions?: LpueOption[];
}

export default function LpueCalcMethod(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<LpueCalcMethodData>(props);

  const dbSamsLpueMethod = data.dbSamsLpueMethod ?? 'dynamic';
  const formValue = formContext?.values?.[SLUG] as string | undefined;
  const samsLpueMethod =
    formValue ??
    data.samsLpueMethod ??
    (pageData?.data?.samsLpueMethod as string | undefined) ??
    dbSamsLpueMethod ??
    'dynamic';
  const lpueOptions =
    data.lpueOptions ??
    (pageData?.data?.lpueOptions as LpueOption[] | undefined) ??
    [];

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      formContext?.setValue(SLUG, e.target.value);
    },
    [formContext]
  );

  return (
    <SAMSLpueMethodSlider
      samsLpueMethod={samsLpueMethod}
      dbSamsLpueMethod={dbSamsLpueMethod}
      handleLpueMethodChange={handleChange}
      updatingParams={data.updatingParams ?? (pageData?.data?.updatingPStar as boolean | undefined) ?? false}
      lpueOptions={lpueOptions}
    />
  );
}
